import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { accountStoreReducer } from '../store/account.reducer';
import { AccountStoreEffects } from '../store/account.effects';
import { RouterModule } from '@angular/router';
import { AccountApiService } from './services/account.api.service';
import { AccountStoreService } from '../store/account.store.service';
import { AccountResolver } from './resolver/account.resolver';
import { AccountUserIdResolver } from './resolver/account.userid.resolver';
import { CurrentAccountResolver } from './resolver/current.account.resolver';
import { IdentityStoreModule } from '@modules/identity/store/identity-store.module';
import { accountFeatureKey } from '../store/account.state';

@NgModule({
  declarations: [],
  exports: [StoreModule, EffectsModule],
  imports: [
    StoreModule.forFeature(accountFeatureKey, accountStoreReducer),
    EffectsModule.forFeature([AccountStoreEffects]),
    CommonModule,
    SharedModule,
    //CardClientModule,
    RouterModule,
    IdentityStoreModule,
  ],
  providers: [
    AccountStoreEffects,
    AccountApiService,
    AccountStoreService,
    AccountResolver,
    AccountUserIdResolver,
    CurrentAccountResolver,
  ],
})
export class AccountClientModule {}
